export const MESSAGES_FEATURE_KEY = 'messages';
